import React from 'react'
import { Button, Form, Input, Select } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx



const DataInput = ({ title }) => {
   const { DataStore } = useStore()

   // 取消按钮
   const [form] = Form.useForm()

   //表单提交
   const onFinish = async (values) => {
      if (title === '添加') {
         await DataStore.getAddButtom(values)
      } else if (title === '编辑') {
         console.log(values, 'bj')
         await DataStore.getPutInformation(values)
      }
      runInAction(() => {
         set(DataStore, { isActive: false })
      })
      form.resetFields()
   };

   return (
      <>

         {
            title === '查看' && <Form
               labelCol={{
                  span: 14,
               }}
               wrapperCol={{
                  span: 18,
               }}
               layout="inline"
               form={form}
               onFinish={onFinish}
               initialValues={toJS(DataStore.valueData)}
               className='check'
            >
               <Form.Item label="企业名称">
                  {DataStore.valueData.qymc}
               </Form.Item>
               <Form.Item label="单元名称">
                  {DataStore.valueData.dymc}
               </Form.Item>
               <Form.Item label="更新时间">
                  {DataStore.valueData.time}
               </Form.Item>
               <Form.Item label="温度">
                  {DataStore.valueData.temperature}
               </Form.Item>
               <Form.Item label="湿度">
                  {DataStore.valueData.humidity}
               </Form.Item>


               <Form.Item label="光照度">
                  {DataStore.valueData.illuminance}
               </Form.Item>

               <Form.Item label="大气压">
                  {DataStore.valueData.atmos}
               </Form.Item>
               <Form.Item label="PM2.5">
                  {DataStore.valueData.PM25}
               </Form.Item>
               <Form.Item label="PM10">
                  {DataStore.valueData.PM10}
               </Form.Item>
               <Form.Item label="二氧化碳">
                  {DataStore.valueData.CarbonDioxide}
               </Form.Item>
               <Form.Item label="风速">
                  {DataStore.valueData.windSpeed}
               </Form.Item>
               <Form.Item label="风向">
                  {DataStore.valueData.windDirection}
               </Form.Item>

               <Form.Item label="雨量">
                  {DataStore.valueData.rainfall}
               </Form.Item>

               <Form.Item label="紫外线">
                  {DataStore.valueData.ultraviolet_rays}
               </Form.Item>
               <Form.Item label="雨雪">
                  {DataStore.valueData.RainSnow}
               </Form.Item>

               <Form.Item label="土壤温度">
                  {DataStore.valueData.soil_temperature}
               </Form.Item>
               <Form.Item label="土壤湿度">
                  {DataStore.valueData.soil_moisture}
               </Form.Item>
               <Form.Item label="土壤PH值">
                  {DataStore.valueData.SoilpH}
               </Form.Item>



               <Form.Item label="土壤电导率">
                  {DataStore.valueData.conductivity}
               </Form.Item>


               <Form.Item label="土壤氮">
                  {DataStore.valueData.nitrogen}
               </Form.Item>
               <Form.Item label="土壤磷">
                  {DataStore.valueData.phosphorus}
               </Form.Item>
               <Form.Item label="土壤钾">
                  {DataStore.valueData.potassium}
               </Form.Item>


            </Form>
         }
      </>
   )
}

export default observer(DataInput)
